"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputCreateConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcInputCreateConstants = (function () {
    function BcInputCreateConstants() {
    }
    BcInputCreateConstants.INPUT_CREATE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-input-create");
    BcInputCreateConstants.TYPE_ATR = "type";
    BcInputCreateConstants.CONDITIONALS_ATR = "conditionals";
    BcInputCreateConstants.TITLE_ATR = "title";
    BcInputCreateConstants.MASK_ATR = "mask";
    BcInputCreateConstants.ID_ATR = "id";
    BcInputCreateConstants.ARIA_CONTROLS_ATR = "aria-controls";
    BcInputCreateConstants.FOR_ATR = "for";
    BcInputCreateConstants.SUPPORT_TEXT_CONDITION_ATR = "supportTextCondition";
    BcInputCreateConstants.FIRST_ICON_ATR = "firstIcon";
    BcInputCreateConstants.SECOND_ICON_ATR = "secondIcon";
    BcInputCreateConstants.THIRD_ICON_ATR = "thirdIcon";
    BcInputCreateConstants.TITLE_ICON_ATR = "titleIcon";
    BcInputCreateConstants.FIRST_LABEL_ATR = "firstLabel";
    BcInputCreateConstants.SECOND_LABEL_ATR = "secondLabel";
    BcInputCreateConstants.THIRD_LABEL_ATR = "thirdLabel";
    BcInputCreateConstants.FIRST_MSG_ERROR_ATR = "firstMsgError";
    BcInputCreateConstants.SECOND_MSG_ERROR_ATR = "secondMsgError";
    BcInputCreateConstants.THIRD_MSG_ERROR_ATR = "thirdMsgError";
    BcInputCreateConstants.FIRST_ID_INPUT_ATR = "firstIdInput";
    BcInputCreateConstants.SECOND_ID_INPUT_ATR = "secondIdInput";
    BcInputCreateConstants.THIRD_ID_INPUT_ATR = "thirdIdInput";
    BcInputCreateConstants.STATUS_ATR = "disableStatus";
    BcInputCreateConstants.CURRENT_PASSWORD_VALUE_DEFAULT = "Clave";
    BcInputCreateConstants.NEW_PASSWORD_VALUE_DEFAULT = "Nueva Clave";
    BcInputCreateConstants.CONFIRM_PASSWORD_VALUE_DEFAULT = "Confirmar nueva Clave";
    BcInputCreateConstants.MSG_ERROR_VALUE_DEFAULT = "La clave no cumple con los criterios requeridos";
    BcInputCreateConstants.MSG_ERROR_VALIDATION_VALUE_DEFAULT = "Las claves no coinciden";
    BcInputCreateConstants.TITLE_VALUE_DEFAULT = "La clave debe contener";
    BcInputCreateConstants.SUPPORT_TEXT_DEFAULT = "Sugerencias";
    BcInputCreateConstants.INPUT_CREATE_8 = 8;
    BcInputCreateConstants.TYPE_USER = "user";
    BcInputCreateConstants.TYPE_PASSWORD = "password";
    BcInputCreateConstants.TYPE_PASSWORD_CREATE = "password-create";
    BcInputCreateConstants.TYPE_PASSWORD_UPDATE = "password-update";
    BcInputCreateConstants.TYPE_TEXT = "text";
    BcInputCreateConstants.TYPE_LOWERCASE = "lowercase";
    BcInputCreateConstants.TYPE_UPPERCASE = "uppercase";
    BcInputCreateConstants.TYPE_CHARACTER = "character";
    BcInputCreateConstants.TYPE_NUMBER = "number";
    BcInputCreateConstants.ICON_USER = "user";
    BcInputCreateConstants.ICON_DOT = "asterisk";
    BcInputCreateConstants.ICON_NO_VIEW = "no-view";
    BcInputCreateConstants.ICON_VIEW = "view";
    BcInputCreateConstants.ICON_OK = "ok";
    BcInputCreateConstants.ICON_ERROR = "error";
    BcInputCreateConstants.ICON_REMOVE = "remove";
    BcInputCreateConstants.ICON_SUCCESSFUL = "successful";
    BcInputCreateConstants.ICON_LOCK = "lock";
    BcInputCreateConstants.CLASS_BUTTON_ICON = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-icon");
    BcInputCreateConstants.CLASS_FORM_FIELD = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-form-field");
    BcInputCreateConstants.CLASS_INPUT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-input");
    BcInputCreateConstants.CLASS_INPUT_SUCCESS = "".concat(BcInputCreateConstants.CLASS_INPUT, "-success");
    BcInputCreateConstants.CLASS_INPUT_ERROR = "".concat(BcInputCreateConstants.CLASS_INPUT, "-error");
    BcInputCreateConstants.CLASS_FIRST_CONTAINER = "".concat(BcInputCreateConstants.INPUT_CREATE, "-first-container");
    BcInputCreateConstants.CLASS_SECOND_CONTAINER = "".concat(BcInputCreateConstants.INPUT_CREATE, "-second-container");
    BcInputCreateConstants.CLASS_THIRD_CONTAINER = "".concat(BcInputCreateConstants.INPUT_CREATE, "-third-container");
    BcInputCreateConstants.CLASS_ICONS_STATE_CONDITION = "icon-state-condition";
    BcInputCreateConstants.DOCUMENT_QUERY = "section[class~='".concat(BcInputCreateConstants.INPUT_CREATE, "']");
    BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER = "".concat(BcInputCreateConstants.INPUT_CREATE, "-container");
    BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL = "".concat(BcInputCreateConstants.INPUT_CREATE, "-equal");
    BcInputCreateConstants.CLASS_INPUT_CREATE_FIRST_INPUT = "".concat(BcInputCreateConstants.INPUT_CREATE, "-first-input");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-content-conditionals");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY = "".concat(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, "-body");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM = "".concat(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY, "-item");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE = "".concat(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM, "-state");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT = "".concat(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM, "-text");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER = "".concat(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, "-header");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER_ICON = "".concat(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER, "-icon");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER_TEXT = "".concat(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER, "-text");
    BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_FOOTER = "".concat(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, "-footer");
    BcInputCreateConstants.CONDITION_SPECIAL_CHARACTERPIPE = "specialCharacterpipe";
    BcInputCreateConstants.CLASS_DROPDOWN_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-dropdown-content");
    BcInputCreateConstants.CLASS_DROPDOWN_CONTENT_ACTIVE = "".concat(BcInputCreateConstants.CLASS_DROPDOWN_CONTENT, "-active");
    BcInputCreateConstants.CLASS_DROPDOWN_TOGGLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-dropdown-toggle");
    BcInputCreateConstants.TRUE_VALUE = "true";
    BcInputCreateConstants.USER_VALUE = "user";
    BcInputCreateConstants.PASSWORD_VALUE = "password";
    BcInputCreateConstants.NEW_PASSWORD_VALUE = "newPassword";
    BcInputCreateConstants.CURRENT_PASSWORD_VALUE = "currentPassword";
    BcInputCreateConstants.VALIDATIONS_VALUE = "validations";
    BcInputCreateConstants.EQUAL_VALUE = "equal";
    BcInputCreateConstants.VISIBLE_VALUE = "visible";
    BcInputCreateConstants.ERROR_VALUE = "error";
    BcInputCreateConstants.SUCCESS_VALUE = "success";
    BcInputCreateConstants.CONDITION_VALUE = "condition";
    BcInputCreateConstants.STATE_VALUE = "state";
    BcInputCreateConstants.CONDITION_MAX_LENGTH = "maxLength";
    BcInputCreateConstants.CONDITION_CAPITAL_LETTERS = "capitalLetters";
    BcInputCreateConstants.CONDITION_SOME_NUMBERS = "someNumbers";
    BcInputCreateConstants.CONDITION_INITIAL_CHARACTERS = "initialCharacter";
    BcInputCreateConstants.CONDITION_SPECIAL_CHARACTER = "specialCharacter";
    BcInputCreateConstants.CONDITION_CONSECUTIVE_NUMBERS = "consecutiveNumbers";
    BcInputCreateConstants.NONE_TEXT = "none";
    BcInputCreateConstants.MY_DROPDOWN_TEXT = "myDropDown";
    BcInputCreateConstants.ID_CONDITION_TEXT = "".concat(BcInputCreateConstants.ID_ATR, "-condition");
    BcInputCreateConstants.FIRST_ID_TEXT = "firstId";
    BcInputCreateConstants.SECOND_ID_TEXT = "secondId";
    BcInputCreateConstants.THIRD_ID_TEXT = "thirdId";
    BcInputCreateConstants.FIRST_TEXT = "first";
    BcInputCreateConstants.EQUAL_TEXT = "equal";
    BcInputCreateConstants.NUMBER_TWO = 2;
    return BcInputCreateConstants;
}());
exports.BcInputCreateConstants = BcInputCreateConstants;
